
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-professional-services",
      function () {
        return require("private-next-pages/industry-professional-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-professional-services"])
      });
    }
  